import { z } from 'zod';

// ==========================================
// Performance Metrics Validation Schema
// ==========================================
export const PerformanceMetricsSchema = z.object({
  views: z.number().int().nonnegative().optional(),
  likes: z.number().int().nonnegative().optional(),
  comments: z.number().int().nonnegative().optional(),
  shares: z.number().int().nonnegative().optional(),
  saves: z.number().int().nonnegative().optional(),
  reach: z.number().int().nonnegative().optional(),
  impressions: z.number().int().nonnegative().optional(),
  replies: z.number().int().nonnegative().optional(),
  engagement_rate: z.number().nonnegative().optional(),
  avg_watch_time_seconds: z.number().nonnegative().optional(),
  watch_through_rate: z.number().nonnegative().optional(),
  extracted_at: z.string().optional(),
  extraction_source: z.enum(['manual', 'apify', 'hikerapi', 'screenshot_ocr']).optional(),
}).optional();

export type ValidatedPerformanceMetrics = z.infer<typeof PerformanceMetricsSchema>;

// ==========================================
// Content Submission Validation Schema
// ==========================================
export const ContentSubmissionSchema = z.object({
  campaign_influencer_id: z.string().uuid(),
  platform: z.enum(['instagram', 'youtube', 'tiktok', 'twitter', 'linkedin']),
  type: z.enum(['reel', 'story', 'post', 'video', 'carousel', 'igtv']),
  post_url: z.string().url().optional().or(z.literal('')),
  submission_url: z.string().url().optional().or(z.literal('')),
  performance_metrics: PerformanceMetricsSchema,
});

export type ValidatedContentSubmission = z.infer<typeof ContentSubmissionSchema>;

// ==========================================
// Add Post Form Validation Schema
// ==========================================
export const addPostFormSchema = z.object({
  platform: z.enum(['instagram', 'youtube', 'tiktok', 'twitter', 'linkedin']),
  type: z.enum(['reel', 'story', 'post', 'video', 'carousel', 'igtv']),
  post_url: z.string().url('Please enter a valid URL'),
  views: z.coerce.number().int().nonnegative().optional(),
  likes: z.coerce.number().int().nonnegative().optional(),
  comments: z.coerce.number().int().nonnegative().optional(),
  shares: z.coerce.number().int().nonnegative().optional(),
  saves: z.coerce.number().int().nonnegative().optional(),
});

export type AddPostFormValues = z.infer<typeof addPostFormSchema>;

// ==========================================
// Edit Post Form Validation Schema
// ==========================================
export const editPostFormSchema = z.object({
  platform: z.enum(['instagram', 'youtube', 'tiktok', 'twitter', 'linkedin']),
  type: z.enum(['reel', 'story', 'post', 'video', 'carousel', 'igtv']),
  status: z.enum(['draft', 'submitted', 'under_review', 'approved', 'rejected', 'published']),
  post_url: z.string().url().optional().or(z.literal('')),
  rejection_reason: z.string().optional(),
  views: z.coerce.number().int().nonnegative().optional(),
  likes: z.coerce.number().int().nonnegative().optional(),
  comments: z.coerce.number().int().nonnegative().optional(),
  shares: z.coerce.number().int().nonnegative().optional(),
  saves: z.coerce.number().int().nonnegative().optional(),
});

export type EditPostFormValues = z.infer<typeof editPostFormSchema>;
